module.exports = __webpack_public_path__ + "images/emoji/arrow_forward.25d8b16bd6b7def3e7a8.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/arrow_forward.png
// module id = mYFP
// module chunks = 24